import UnassignList from "./unassignListing.container";

export default UnassignList;
